"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(obj, propertyPath) {
  if (!propertyPath) return null;
  var properties = propertyPath.split(".");

  for (var i = 0; i < properties.length; i++) {
    var prop = properties[i];

    if (!obj || !obj.hasOwnProperty(prop)) {
      return null;
    } else {
      obj = obj[prop];
    }
  }

  return obj;
};

exports["default"] = _default;